import { getCurrentOrgId, isOrgUiEnabled } from '@thoughtspot/session-service';
import { isOktaEnabled, isSamlEnabled, } from '@thoughtspot/system-config-service';
import React, { useCallback, useEffect, useState } from 'react';
import { useGetUserAccessibleOrgsLazyQuery } from "../../../services/session/session-service";
import { SAMLContainer } from '../../authentication/saml';
import { SamlConfig } from '../saml-config/saml-config';
export const SamlContainer = () => {
    const [isIdentityProviderDetails, setIsIdentityProviderDetails] = useState(false);
    const [currentOrgInfo, setCurrentOrgInfo] = useState(null);
    const [isListEmptyAndIAMV2MigrationBannerEnabled, setIsListEmptyAndIAMV2MigrationBannerEnabled,] = useState(false);
    const { error: orgError, data: orgsList, loading: orgsLoading, getUserAccessibleOrgsLazy, } = useGetUserAccessibleOrgsLazyQuery();
    useEffect(() => {
        if (isOrgUiEnabled()) {
            getUserAccessibleOrgsLazy();
        }
    }, []);
    useEffect(() => {
        if (orgsList) {
            const orgsData = orgsList?.Data?.orgs || [];
            const selectedOrg = orgsData.filter((org) => org.orgId === getCurrentOrgId().toString());
            const org = selectedOrg.length === 0 ? null : selectedOrg[0];
            setCurrentOrgInfo(org);
        }
    }, [orgsList]);
    const showIAMV2MigrationBannerWhenEnabled = useCallback(() => {
        const isOktaSamlEnabled = isOktaEnabled() && isSamlEnabled();
        if (isOktaSamlEnabled) {
            setIsListEmptyAndIAMV2MigrationBannerEnabled(true);
        }
    }, []);
    if (isListEmptyAndIAMV2MigrationBannerEnabled) {
        return React.createElement(SAMLContainer, null);
    }
    return (React.createElement(SamlConfig, { isIdentityProviderDetails: isIdentityProviderDetails, setIsIdentityProviderDetails: setIsIdentityProviderDetails, showIAMV2MigrationBannerWhenEnabled: showIAMV2MigrationBannerWhenEnabled, currentOrgInfo: currentOrgInfo }));
};
//# sourceMappingURL=saml.container.js.map